import { gql } from '@apollo/client'

export const CITIES_QUERY = gql`
  query Cities {
    cities {
      nameEn
      nameFa
      cityID
    }
  }
`
